// src/components/Footer.js
import React from "react";
import { Box, Text, Stack, Link, Flex, Icon } from "@chakra-ui/react";
import { FaInstagram, FaTwitter, FaLinkedin, FaWhatsapp } from "react-icons/fa";

export default function Footer() {
  return (
    <Box bg="gray.100" py={8} mt={16} px={6}>
      <Flex direction={{ base: "column", md: "row" }} justify="space-between" align="center" maxW="6xl" mx="auto">
        <Stack spacing={2} align="flex-start">
          <Text fontSize="sm" color="gray.600">
            <strong>Customer Support:</strong>
          </Text>
          <Link href="mailto:support@serenaspace.com" fontSize="sm" color="gray.600">
            support@serenaspace.com
          </Link>
          <Flex align="center">
            <Link href="https://wa.me/2349127121273" isExternal display="flex" alignItems="center" color="green.500" mr={2}>
              <Icon as={FaWhatsapp} boxSize={5} mr={1} />
              WhatsApp: +2349127121273
            </Link>
          </Flex>
          <Link href="tel:+2349127121273" fontSize="sm" color="gray.600">
            Call: +2349127121273
          </Link>
        </Stack>

        <Stack direction="row" spacing={6} align="center" mt={{ base: 4, md: 0 }}>
          <Link href="/app/privacy" fontSize="sm" color="gray.600">Privacy Policy</Link>
          <Link href="https://twitter.com/https://x.com/serena_hq?s=21" isExternal><Icon as={FaTwitter} boxSize={5} /></Link>
          <Link href="https://instagram.com/https://www.instagram.com/serena_spacehq?igsh=MTk1amJjZWNhd2dzYQ%3D%3D&utm_source=qr" isExternal><Icon as={FaInstagram} boxSize={5} /></Link>
          <Link href="https://linkedin.com/https://www.linkedin.com/company/serena-space/" isExternal><Icon as={FaLinkedin} boxSize={5} /></Link>
        </Stack>
      </Flex>
    </Box>
  );
}
